import React, { Children, Fragment } from 'react';
import { motion } from 'framer-motion';
const problems = [{
  icon: () => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-brand-gold" data-id="element-1863">
        <circle cx="16" cy="12" r="8" stroke="currentColor" strokeWidth="1.5" data-id="element-1864" />
        <circle cx="16" cy="20" r="8" stroke="currentColor" strokeWidth="1.5" data-id="element-1865" />
        <line x1="16" y1="4" x2="16" y2="28" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2 4" data-id="element-1866" />
      </svg>,
  title: 'BLOCAJE INTERIOARE',
  subtitle: 'FRICI · CREDINȚE LIMITATIVE · STAGNARE',
  text: 'Simți că ceva te ține pe loc, dar nu știi exact ce. Ai încercat să te schimbi, dar parcă te lovești mereu de același zid invizibil. Poate e o frică veche, poate e o credință pe care nici nu o conștientizezi. Știi doar că nu mai vrei să rămâi aici.'
}, {
  icon: () => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-brand-gold" data-id="element-1867">
        <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" data-id="element-1868" />
        <path d="M11 16C11 13.2386 13.2386 11 16 11C18.7614 11 21 13.2386 21 16C21 18.7614 18.7614 21 16 21C13.2386 21 11 18.7614 11 16Z" stroke="currentColor" strokeWidth="1.5" data-id="element-1869" />
        <path d="M11 16C11 18.7614 8.76142 21 6 21C3.23858 21 1 18.7614 1 16C1 13.2386 3.23858 11 6 11C8.76142 11 11 13.2386 11 16Z" stroke="currentColor" strokeWidth="1.5" data-id="element-1870" />
        <path d="M21 16C21 18.7614 23.2386 21 26 21C28.7614 21 31 18.7614 31 16C31 13.2386 28.7614 11 26 11C23.2386 11 21 13.2386 21 16Z" stroke="currentColor" strokeWidth="1.5" data-id="element-1871" />
      </svg>,
  title: 'RELAȚIA CU BANII',
  subtitle: 'LIPSĂ · NEAJUNS · STRES FINANCIAR',
  text: 'Oricât ai munci, parcă nu e de ajuns. Banii vin greu și pleacă repede. Te blochezi mereu în același punct și nu înțelegi de ce alții par să atragă ușor ceea ce ție nu îți iese. Simți că abundența e pentru alții, nu pentru tine.'
}, {
  icon: () => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-brand-gold" data-id="element-1872">
        <path d="M16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 11.5303 4.09241 7.5501 7.33924 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-1873" />
        <path d="M12 8L14 10L12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1874" />
        <path d="M16 4L14 6L16 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1875" />
        <circle cx="10" cy="10" r="1" fill="currentColor" data-id="element-1876" />
      </svg>,
  title: 'LIPSĂ DE ÎMPLINIRE',
  subtitle: 'STRES · ANXIETATE · GOL INTERIOR',
  text: 'Pe hârtie, viața ta arată bine. Dar în interior simți un gol pe care nu îl poți explica. Muncești mult, dar nu te simți împlinit/ă. Ești obosit/ă de stres, de alergat și de sentimentul că trece viața pe lângă tine fără să o trăiești cu adevărat.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function ProblemsSection() {
  return <section className="py-20 lg:py-32 bg-gradient-to-br from-[#6B3FA0] via-[#5C3490] to-[#3D1F5C] relative overflow-hidden" data-id="element-1877">
      {/* Asymmetric decorative gradient overlay */}
      <div className="absolute top-0 left-0 w-[60%] h-[60%] bg-gradient-to-br from-white/[0.04] to-transparent rounded-br-full pointer-events-none" data-id="element-1878" />
      <div className="absolute bottom-0 right-0 w-[40%] h-[40%] bg-gradient-to-tl from-brand-gold/[0.05] to-transparent rounded-tl-full pointer-events-none" data-id="element-1879" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-1880">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 lg:mb-24" data-id="element-1881">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-1882">
            Te regăsești în cel puțin una din aceste situații?
          </h2>
          <div className="h-[2px] w-16 bg-brand-gold mx-auto rounded-full" data-id="element-1883" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1884">
          {problems.map((problem, index) => <motion.div key={index} variants={itemVariants} className="bg-white/[0.12] backdrop-blur-md rounded-3xl p-8 lg:p-10 border border-white/15 hover:border-brand-gold/50 transition-all duration-300 hover:-translate-y-2" data-id="element-1885">
              <div className="w-20 h-20 rounded-full bg-white/[0.10] border border-brand-gold/50 flex items-center justify-center mb-8" data-id="element-1886">
                <problem.icon data-id="element-1887" />
              </div>

              <h3 className="font-heading font-bold text-xl text-white mb-3" data-id="element-1888">
                {problem.title}
              </h3>

              <p className="font-heading font-bold text-sm tracking-[0.1em] text-brand-gold mb-6" data-id="element-1889">
                {problem.subtitle.split('·').map((part, i, arr) => <Fragment key={i} data-id="element-1890">
                    {part.trim()}
                    {i < arr.length - 1 && <span className="mx-2 text-brand-gold/50" data-id="element-1891">·</span>}
                  </Fragment>)}
              </p>

              <p className="text-white leading-relaxed" data-id="element-1892">{problem.text}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}